var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExpirationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#018747",
  d: "M10.833 2.5h3.333v1.667h-3.333zM2.5 6.667h3.333v1.666H2.5zm0 6.666h3.333V15H2.5zM1.667 10h3.325v1.667H1.667zm16.422-4.41-1.178-1.18-1.423 1.423A5.8 5.8 0 0 0 12.5 5a5.84 5.84 0 0 0-5.833 5.833 5.84 5.84 0 0 0 5.833 5.834 5.84 5.84 0 0 0 5.833-5.834c0-1.52-.59-2.902-1.546-3.941zm-4.756 6.077h-1.667V7.465h1.667z"
})));
export default SvgExpirationIcon;